import type { AIContentClassification, SupportedAIApp } from '../types';

export type ProvenanceLogEvent = {
  event:
    | 'ai_provenance_applied'
    | 'ai_provenance_failed'
    | 'ai_provenance_skipped'
    | 'ai_transparency_recorded';
  app?: SupportedAIApp | string;
  assetId?: string;
  classification?: AIContentClassification;
  success: boolean;
  reason?: string;
  operation?: string;
};

/** Structured server-side logging — never log secrets or full prompts. */
export function logProvenanceEvent(payload: ProvenanceLogEvent): void {
  const safe = {
    ...payload,
    ts: new Date().toISOString(),
  };
  // eslint-disable-next-line no-console
  console.log(JSON.stringify(safe));
}
